import { request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { DashboardPanelCollectionModel } from "@insite/client-framework/Types/ApiModels";

const giftCardUrl = "/api/v1/dashboardpanels";

export async function getAllDashboardPanels(): Promise<ServiceResult<DashboardPanelCollectionModel>> {
    try {
        const data = await request<DashboardPanelCollectionModel>(giftCardUrl, "GET");
        return {
            successful: true,
            result: data,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
